// import { useState, useEffect, useContext, useCallback, useMemo } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square.svg";
// import Spinner from "../../spinner/Spinner";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
// import ApiServices from "../../../api/ApiServices";
// import { AuthContext } from "../../../AuthProvider/AuthProvider";
// import formatDate from "../../../components/utils/DateFormatter";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { Link, useNavigate } from "react-router-dom";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";

// const GetPendingRemittance = () => {
//   const [pendingRemittance, setPendingRemittance] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [updatingPendingRemittance, setUpdatingPendingRemittance] = useState(false);
//   const [toggleCleared, setToggleCleared] = useState(false);
//   const [bulkLoading, setBulkLoading] = useState(false);
//   const { permissions } = useContext(AuthContext);
//   // console.log("perm", permissions);
//   const axios = AxiosApiCall();
//   const navigate = useNavigate();

//   const fetchPendingRemittance = async () => {
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const response = await axios.get(ApiServices.getPendingRemittance, {
//         headers: { Authorization: `Bearer ${token}` },
//         withCredentials: true,
//       });

//       const { status, message, data } = response.data || {};
//       const remittances = data?.remittances || [];

//       if (status === 200) {
//         setPendingRemittance(remittances.reverse());
//         toast.success(message, { toastId: "pendingRemittance-fetch-success" });
//       } else {
//         handleError({ response: { status, data: { message } } });
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPendingRemittance();
//   }, []);

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   // Approve remittance Function
//   const approvePendingRemittance = async (remittance_id, action) => {
//     try {
//       setUpdatingPendingRemittance(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = { remittance_id, action };
//       // console.log("payload", payload);
//       const response = await axios.post(ApiServices.acceptProcessRemittance, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "remittance-approve-success" });
//         await fetchPendingRemittance();
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setUpdatingPendingRemittance(false);
//     }
//   };

//   // Reject Purchase Function
//   const rejectPendingRemittance = async (remittance_id, action, rejection_reason) => {
//     try {
//       setUpdatingPendingRemittance(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = { remittance_id, action, rejection_reason };
//       console.log("payload", payload);
//       const response = await axios.post(ApiServices.rejectPurchaseItem, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "remittance-reject-success" });
//         await fetchPendingRemittance();
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setUpdatingPendingRemittance(false);
//     }
//   };

//   // Bulk Approve Purchases Function
//   const bulkApproveRemittance = async (remittanceIds) => {
//     try {
//       setBulkLoading(true);
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) throw new Error("No access token found.");

//       const payload = { remittance_ids: remittanceIds };

//       // console.log("Bulk Approve Payload:", payload);
//       const response = await axios.post(ApiServices.bulkRemittanceApproval, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       });

//       const { status, message } = response.data;
//       if (status === 200) {
//         toast.success(message, { toastId: "bulk-remittance-approve-success" });
//         await fetchPendingRemittance();
//         setSelectedRows([]);
//         setToggleCleared(!toggleCleared);
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setBulkLoading(false);
//     }
//   };

//   const handleApprovalConfirmation = async (remittance) => {
//     const { id, branch_name, remittance_number, amount } = remittance;

//     const { value: action } = await Swal.fire({
//       title: "Process Remittance Request",
//       html: `
//       <div class="text-left">
//         <div class="mb-3">
//           <p class="text-sm text-gray-600">Remittance Number: <span class="font-semibold">${remittance_number}</span></p>
//           <p class="text-sm text-gray-600">Branch: <span class="font-semibold">${branch_name}</span></p>
//         </div>
//         <p class="text-lg font-semibold text-gray-800">
//           Amount: <span class="text-darkGreen3">${CurrencyFormatter(amount)}</span>
//         </p>
//       </div>
//     `,
//       showCancelButton: true,
//       showDenyButton: true,
//       confirmButtonText: "Approve",
//       denyButtonText: "Reject",
//       cancelButtonText: "Cancel",
//       icon: "question",
//       confirmButtonColor: "#3085d6",
//       denyButtonColor: "#d33",
//       cancelButtonColor: "#6c757d"
//     });

//     if (action === undefined) return;

//     // === APPROVE ===
//     if (action === true) {
//       const confirm = await Swal.fire({
//         title: "Confirm Approval",
//         text: `Are you sure you want to approve remittance ${remittance_number}?`,
//         icon: "question",
//         showCancelButton: true,
//         confirmButtonText: "Yes, Approve",
//         confirmButtonColor: "#3085d6",
//         cancelButtonText: "Cancel"
//       });

//       if (confirm.isConfirmed) {
//         const payload = {
//           remittance_id: id,
//           action: "approve",
//         };
//         // console.log("Approve Payload:", payload);
//         await approvePendingRemittance(payload.remittance_id, payload.action);
//       }
//     }

//     // === REJECT ===
//     else if (action === false) {
//       const { value: rejectValues } = await Swal.fire({
//         title: "Reject Remittance",
//         html: `
//         <div class="text-left">
//           <div class="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
//             <p class="text-sm text-gray-700"><span class="font-semibold">Remittance:</span> ${remittance_number}</p>
//             <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
//             <p class="text-sm text-gray-700"><span class="font-semibold">Amount:</span>
//               <span class="text-darkGreen3 font-bold">${CurrencyFormatter(amount)}</span></p>
//           </div>
//           <label class="block text-gray-700 mb-2 font-semibold">Rejection Reason *</label>
//           <textarea id="rejection_reason" placeholder="Please provide a reason for rejection..."
//             class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent mb-4"
//             rows="3" required></textarea>
//         </div>
//       `,
//         focusConfirm: false,
//         showCancelButton: true,
//         confirmButtonText: "Confirm Rejection",
//         confirmButtonColor: "#d33",
//         cancelButtonText: "Cancel",
//         preConfirm: () => {
//           const rejection_reason = document.getElementById("rejection_reason").value.trim();
//           if (!rejection_reason) {
//             Swal.showValidationMessage("Rejection reason is required");
//             return;
//           }
//           return { rejection_reason };
//         },
//       });

//       if (rejectValues) {
//         const payload = {
//           remittance_id: id,
//           action: "reject",
//           rejection_reason: rejectValues.rejection_reason,
//         };
//         // console.log("Reject Payload:", payload);
//         await rejectPendingRemittance(payload.remittance_id, payload.action, payload.rejection_reason);
//       }
//     }
//   };

//   // Handle row selection
//   const handleRowSelected = useCallback((state) => {
//     // console.log("Row Selected State:", state.selectedRows);
//     setSelectedRows(state.selectedRows);
//   }, []);

//   // Handle bulk approval
//   const handleBulkApproval = async () => {
//     // console.log("Selected Rows:", selectedRows); 
//     if (selectedRows.length === 0) {
//       toast.warning("Please select at least one remittance to approve", { toastId: "no-selection-warning" });
//       return;
//     }

//     const remittanceIds = selectedRows.map(row => row.id); 
//     const totalAmount = selectedRows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

//     const result = await Swal.fire({
//       title: "Bulk Approval for Remittance",
//       html: `
//       <div class="text-left">
//         <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
//           <p class="text-sm text-gray-700"><span class="font-semibold">Selected Remittances:</span> ${selectedRows.length}</p>
//           <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(totalAmount)}</span></p>
//         </div>
//       </div>
//     `,
//       showCancelButton: true,
//       confirmButtonText: bulkLoading ? "Approving..." : `Approve ${selectedRows.length} Remittances`,
//       confirmButtonColor: "#3085d6",
//       cancelButtonText: "Cancel",
//     });

//     if (result.isConfirmed) {
//       console.log("Sending remittance IDs:", remittanceIds);
//       await bulkApproveRemittance(remittanceIds);
//     }
//   };



//   // Context actions for bulk operations
//   const contextActions = useMemo(() => {
//     if (!permissions.some(p => p.name === "branch.remittance.approve")) return null;

//     return (
//       <div className="flex justify-end mb-4">
//         <button
//           onClick={handleBulkApproval}
//           disabled={bulkLoading || selectedRows.length === 0}
//           className="flex items-center gap-2 px-4 py-2 bg-darkGreen3 text-white rounded-lg hover:bg-green-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           <CheckSquare className="w-4 h-4" />
//           {bulkLoading
//             ? "Processing..."
//             : `Approve Selected (${selectedRows.length})`}
//         </button>
//       </div>
//     );
//   }, [permissions, selectedRows.length, bulkLoading]);



//   const ExpandableComponent = ({ data }) => {
//     return (
//       <div className="flex justify-start p-4 relative">
//         {permissions.some(permission => permission.name === 'branch.remittance.view') && (
//           <>
//             <div className="mx-2 my-2 group relative">
//               <Link to="/operations/branch/remittance/pending/details" state={{ remittanceData: data }}>
//                 <Eye className="w-5 h-5 text-darkGreen3" />
//               </Link>
//               <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen3 text-xs px-2 py-1 rounded">
//                 Details
//               </div>
//             </div>
//           </>
//         )}
//         {permissions.some(permission => permission.name === 'branch.remittance.approve') && (
//           <div className="flex items-center justify-start gap-3 ">
//             <div className="mx-2 group relative">
//               <button
//                 onClick={() => handleApprovalConfirmation(data)}
//                 className="p-2 rounded hover:bg-gray-200 transition disabled:opacity-50"
//               >
//                 <PlusSquareFill className="w-5 h-5 text-darkGreen3" />
//               </button>
//               <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-darkGreen3 text-xs px-2 py-1 rounded whitespace-nowrap z-10">
//                 Approve/Reject
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     );
//   };

//   const columns = [
//     {
//       name: "Remittance No",
//       selector: (row) => row.remittance_number ? row.remittance_number : "NOT AVAILABLE",
//       sortable: true,
//       width: "220px",
//     },
//     {
//       name: "Branch",
//       selector: (row) => row.branch?.name.toUpperCase() || "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Type",
//       selector: (row) => row.type_label ? row.type_label.toUpperCase() : "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Amount",
//       selector: (row) => CurrencyFormatter(row.amount) ? row.amount : "0:00",
//       sortable: true,
//       width: "160px",
//     },
//     {
//       name: "Status",
//       selector: (row) => row.status ? row.status : "NOT AVAILABLE",
//       sortable: true,
//       width: "160px",
//       cell: (row) => (
//         <span
//           className={
//             row.status === "pending"
//               ? "text-orange1"
//               : row.status === "completed"
//                 ? "text-green-600"
//                 : row.status === "rejected"
//                   ? "text-red-600"
//                   : "text-darkGreen3"
//           }
//         >
//           {row.status.toUpperCase()}
//         </span>
//       ),
//     },
//     {
//       name: "Description",
//       selector: (row) => row.description ? row.description.toUpperCase() : "NOT AVAILABLE",
//       wrap: true,
//       width: "300px",
//     },
//     {
//       name: "Date Submitted",
//       selector: (row) => formatDate(row.submitted_at) ? formatDate(row.submitted_at) : "NOT AVAILABLE",
//       width: "200px",
//     },
//   ];



//   const filteredItems = pendingRemittance.filter((item) =>
//     Object.values(item || {})
//       .join(" ")
//       .toLowerCase()
//       .includes(filterText.toLowerCase())
//   );

//   const data = filteredItems.map((remittance) => ({
//     id: remittance.id,
//     remittance_number: remittance.remittance_number,
//     type: remittance.type,
//     type_label: remittance.type_label,
//     amount: remittance.amount,
//     description: remittance.description,
//     branch: remittance.branch,
//     branch_note: remittance.branch_note,
//     status: remittance.status,
//     rejection_reason: remittance.rejection_reason,
//     reference: remittance.reference,
//     submitted_at: remittance.submitted_at,
//     approved_at: remittance.approved_at,
//     completed_at: remittance.completed_at,
//     created_at: remittance.created_at,
//     time_ago: remittance.time_ago,
//     branch_name: remittance.branch?.name,
//     branch_email: remittance.branch?.email,
//     branch_phone: remittance.branch?.phone_number,
//   }));



//   return (
//     <MainLayouts>
//       <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//         {/* Breadcrumb */}
//         <section
//           className="w-full pr-[3%] pt-3 my-3"
//           style={{ backgroundColor: "#F7F7F7" }}
//         >
//           <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//             <ol className="list-none p-0 inline-flex mb-2">
//               <li className="flex items-center">
//                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                   Operations
//                 </p>
//                 <ChevronRightIcon />
//               </li>
//               <li className="flex items-center">
//                 <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                   Remittance
//                 </p>
//                 <ChevronRightIcon />
//               </li>
//               <li className="flex items-center">
//                 <p className="text-orange1">Pending</p>
//               </li>
//             </ol>
//           </nav>
//         </section>
//         {selectedRows.length > 0 && (
//           <div className="sticky top-0 z-10 bg-darkGreen3-50 border border-darkGreen3 rounded-lg mb-3 p-3 flex items-center justify-between shadow-sm">
//             <div>
//               <p className="text-darkGreen3 font-semibold">{selectedRows.length} selected</p>
//               <p className="text-sm text-darkGreen3">
//                 Total Amount: {CurrencyFormatter(selectedRows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0))}
//               </p>
//             </div>
//             <button
//               onClick={handleBulkApproval}
//               disabled={bulkLoading}
//               className="bg-darkGreen3 text-lGrey px-4 py-2 rounded-lg hover:bg-darkGreen3-700 transition-all disabled:opacity-50"
//             >
//               {bulkLoading ? "Processing..." : `Approve Selected (${selectedRows.length})`}
//             </button>
//           </div>
//         )}

//         {/* Search Bar */}
//         <div className="pb-4 bg-white flex flex-wrap justify-between">
//           <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//             <input
//               type="search"
//               className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-darkGreen3 focus:border-transparent"
//               placeholder="Search remittance by number, branch, description..."
//               value={filterText}
//               onChange={handleFilter}
//             />
//           </div>
//         </div>

//         {/* Table */}
//         {loading ? (
//           <Spinner />
//         ) : (
//           <DataTable
//             columns={columns}
//             data={data}
//             pagination
//             highlightOnHover
//             striped
//             customStyles={CustomStyles}
//             noDataComponent={
//               <div className="py-8 text-center text-gray-500">
//                 No pending remittance found
//               </div>
//             }
//             expandableRows
//             expandableRowsComponent={ExpandableComponent}
//             selectableRows
//             onSelectedRowsChange={handleRowSelected} // use your existing callback
//             clearSelectedRows={toggleCleared}        //this triggers clear when toggled
//             contextActions={contextActions}          //shows bulk action bar
//             persistTableHead
//           />

//         )}
//       </div>
//     </MainLayouts>
//   );
// };

// export default GetPendingRemittance;


import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import Spinner from "../../spinner/Spinner";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import ApiServices from "../../../api/ApiServices";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import formatDate from "../../../components/utils/DateFormatter";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { downloadCSVFromApi } from "../../../components/utils/DownlaodCSVFromApi";

const GetPendingRemittance = () => {
  const [pendingRemittance, setPendingRemittance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [updatingPendingRemittance, setUpdatingPendingRemittance] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const { permissions } = useContext(AuthContext);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const axios = AxiosApiCall();
  const navigate = useNavigate();

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  const fetchPendingRemittance = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.get(ApiServices.getPendingRemittance, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      const { status, message, data } = response.data || {};
      const remittances = data?.remittances || [];

      if (status === 200) {
        setPendingRemittance(remittances.reverse());
        toast.success(message, { toastId: "pendingRemittance-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } });
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingRemittance();
  }, []);

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Handle CSV Download
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload
      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        status: "pending", // Specifically for pending remittances
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `pending_remittance_${startDateFormatted}_to_${endDateFormatted}.csv`;

      await downloadCSVFromApi(
        ApiServices.getPendingRemittance, // Use the pending remittance endpoint
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000
        }
      );

    } catch (error) {
      // console.error("Download error:", error);
      handleError(error, navigate);
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Approve remittance Function
  const approvePendingRemittance = async (remittance_id, action) => {
    try {
      setUpdatingPendingRemittance(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = { remittance_id, action };
      const response = await axios.post(ApiServices.acceptProcessRemittance, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "remittance-approve-success" });
        await fetchPendingRemittance();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setUpdatingPendingRemittance(false);
    }
  };

  // Reject Purchase Function
  const rejectPendingRemittance = async (remittance_id, action, rejection_reason) => {
    try {
      setUpdatingPendingRemittance(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = { remittance_id, action, rejection_reason };
      const response = await axios.post(ApiServices.rejectPurchaseItem, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "remittance-reject-success" });
        await fetchPendingRemittance();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setUpdatingPendingRemittance(false);
    }
  };

  // Bulk Approve Purchases Function
  const bulkApproveRemittance = async (remittanceIds) => {
    try {
      setBulkLoading(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const payload = { remittance_ids: remittanceIds };

      const response = await axios.post(ApiServices.bulkRemittanceApproval, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "bulk-remittance-approve-success" });
        await fetchPendingRemittance();
        setSelectedRows([]);
        setToggleCleared(!toggleCleared);
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setBulkLoading(false);
    }
  };

  const handleApprovalConfirmation = async (remittance) => {
    const { id, branch_name, remittance_number, amount } = remittance;

    const { value: action } = await Swal.fire({
      title: "Process Remittance Request",
      html: `
      <div class="text-left">
        <div class="mb-3">
          <p class="text-sm text-gray-600">Remittance Number: <span class="font-semibold">${remittance_number}</span></p>
          <p class="text-sm text-gray-600">Branch: <span class="font-semibold">${branch_name}</span></p>
        </div>
        <p class="text-lg font-semibold text-gray-800">
          Amount: <span class="text-darkGreen3">${CurrencyFormatter(amount)}</span>
        </p>
      </div>
    `,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Approve",
      denyButtonText: "Reject",
      cancelButtonText: "Cancel",
      icon: "question",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#d33",
      cancelButtonColor: "#6c757d"
    });

    if (action === undefined) return;

    // === APPROVE ===
    if (action === true) {
      const confirm = await Swal.fire({
        title: "Confirm Approval",
        text: `Are you sure you want to approve remittance ${remittance_number}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve",
        confirmButtonColor: "#3085d6",
        cancelButtonText: "Cancel"
      });

      if (confirm.isConfirmed) {
        const payload = {
          remittance_id: id,
          action: "approve",
        };
        await approvePendingRemittance(payload.remittance_id, payload.action);
      }
    }

    // === REJECT ===
    else if (action === false) {
      const { value: rejectValues } = await Swal.fire({
        title: "Reject Remittance",
        html: `
        <div class="text-left">
          <div class="mb-4 p-3 bg-red-50 rounded-lg border border-red-200">
            <p class="text-sm text-gray-700"><span class="font-semibold">Remittance:</span> ${remittance_number}</p>
            <p class="text-sm text-gray-700"><span class="font-semibold">Branch:</span> ${branch_name}</p>
            <p class="text-sm text-gray-700"><span class="font-semibold">Amount:</span>
              <span class="text-darkGreen3 font-bold">${CurrencyFormatter(amount)}</span></p>
          </div>
          <label class="block text-gray-700 mb-2 font-semibold">Rejection Reason *</label>
          <textarea id="rejection_reason" placeholder="Please provide a reason for rejection..."
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent mb-4"
            rows="3" required></textarea>
        </div>
      `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Confirm Rejection",
        confirmButtonColor: "#d33",
        cancelButtonText: "Cancel",
        preConfirm: () => {
          const rejection_reason = document.getElementById("rejection_reason").value.trim();
          if (!rejection_reason) {
            Swal.showValidationMessage("Rejection reason is required");
            return;
          }
          return { rejection_reason };
        },
      });

      if (rejectValues) {
        const payload = {
          remittance_id: id,
          action: "reject",
          rejection_reason: rejectValues.rejection_reason,
        };
        await rejectPendingRemittance(payload.remittance_id, payload.action, payload.rejection_reason);
      }
    }
  };

  // Handle row selection
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  // Handle bulk approval
  const handleBulkApproval = async () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one remittance to approve", { toastId: "no-selection-warning" });
      return;
    }

    const remittanceIds = selectedRows.map(row => row.id);
    const totalAmount = selectedRows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

    const result = await Swal.fire({
      title: "Bulk Approval for Remittance",
      html: `
      <div class="text-left">
        <div class="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p class="text-sm text-gray-700"><span class="font-semibold">Selected Remittances:</span> ${selectedRows.length}</p>
          <p class="text-sm text-gray-700"><span class="font-semibold">Total Amount:</span> <span class="text-darkGreen3 font-bold">${CurrencyFormatter(totalAmount)}</span></p>
        </div>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: bulkLoading ? "Approving..." : `Approve ${selectedRows.length} Remittances`,
      confirmButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      await bulkApproveRemittance(remittanceIds);
    }
  };

  // Context actions for bulk operations
  const contextActions = useMemo(() => {
    if (!permissions.some(p => p.name === "branch.remittance.approve")) return null;

    return (
      <div className="flex justify-end mb-4">
        <button
          onClick={handleBulkApproval}
          disabled={bulkLoading || selectedRows.length === 0}
          className="flex items-center gap-2 px-4 py-2 bg-darkGreen3 text-white rounded-lg hover:bg-green-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <CheckSquare className="w-4 h-4" />
          {bulkLoading
            ? "Processing..."
            : `Approve Selected (${selectedRows.length})`}
        </button>
      </div>
    );
  }, [permissions, selectedRows.length, bulkLoading]);

  const ExpandableComponent = ({ data }) => {
    return (
      <div className="flex justify-start p-4 relative">
        {permissions.some(permission => permission.name === 'branch.remittance.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/remittance/pending/details" state={{ remittanceData: data }}>
                <Eye className="w-5 h-5 text-darkGreen3" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen3 text-xs px-2 py-1 rounded">
                Details
              </div>
            </div>
          </>
        )}
        {permissions.some(permission => permission.name === 'branch.remittance.approve') && (
          <div className="flex items-center justify-start gap-3 ">
            <div className="mx-2 group relative">
              <button
                onClick={() => handleApprovalConfirmation(data)}
                className="p-2 rounded hover:bg-gray-200 transition disabled:opacity-50"
              >
                <PlusSquareFill className="w-5 h-5 text-darkGreen3" />
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-darkGreen3 text-xs px-2 py-1 rounded whitespace-nowrap z-10">
                Approve/Reject
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      name: "Remittance No",
      selector: (row) => row.remittance_number ? row.remittance_number : "NOT AVAILABLE",
      sortable: true,
      width: "220px",
    },
    {
      name: "Branch",
      selector: (row) => row.branch?.name.toUpperCase() || "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Type",
      selector: (row) => row.type_label ? row.type_label.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Amount",
      selector: (row) => CurrencyFormatter(row.amount) ? row.amount : "0:00",
      sortable: true,
      width: "160px",
    },
    {
      name: "Status",
      selector: (row) => row.status ? row.status : "NOT AVAILABLE",
      sortable: true,
      width: "160px",
      cell: (row) => (
        <span
          className={
            row.status === "pending"
              ? "text-orange1"
              : row.status === "completed"
                ? "text-green-600"
                : row.status === "rejected"
                  ? "text-red-600"
                  : "text-darkGreen3"
          }
        >
          {row.status.toUpperCase()}
        </span>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.description ? row.description.toUpperCase() : "NOT AVAILABLE",
      wrap: true,
      width: "300px",
    },
    {
      name: "Date Submitted",
      selector: (row) => formatDate(row.submitted_at) ? formatDate(row.submitted_at) : "NOT AVAILABLE",
      width: "200px",
    },
  ];

  // Filter data based on search text and date range
  const filteredItems = pendingRemittance.filter((item) => {
    // Filter by search text
    const matchesFilterText = Object.values(item || {})
      .join(" ")
      .toLowerCase()
      .includes(filterText.toLowerCase());

    // Filter by date range (if dates are selected)
    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.submitted_at || item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);

      // Set time to end of day for end date
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesDateRange;
  });

  const data = filteredItems.map((remittance) => ({
    id: remittance.id,
    remittance_number: remittance.remittance_number,
    type: remittance.type,
    type_label: remittance.type_label,
    amount: remittance.amount,
    description: remittance.description,
    branch: remittance.branch,
    branch_note: remittance.branch_note,
    status: remittance.status,
    rejection_reason: remittance.rejection_reason,
    reference: remittance.reference,
    submitted_at: remittance.submitted_at,
    approved_at: remittance.approved_at,
    completed_at: remittance.completed_at,
    created_at: remittance.created_at,
    time_ago: remittance.time_ago,
    branch_name: remittance.branch?.name,
    branch_email: remittance.branch?.email,
    branch_phone: remittance.branch?.phone_number,
  }));

  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        {/* Breadcrumb */}
        <section
          className="w-full pr-[3%] pt-3 my-3"
          style={{ backgroundColor: "#F7F7F7" }}
        >
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                  Operations
                </p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                  Remittance
                </p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Pending</p>
              </li>
            </ol>
          </nav>
        </section>

        {/* Bulk Selection Banner */}
        {selectedRows.length > 0 && (
          <div className="sticky top-0 z-10 bg-darkGreen3-50 border border-darkGreen3 rounded-lg mb-3 p-3 flex items-center justify-between shadow-sm">
            <div>
              <p className="text-darkGreen3 font-semibold">{selectedRows.length} selected</p>
              <p className="text-sm text-darkGreen3">
                Total Amount: {CurrencyFormatter(selectedRows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0))}
              </p>
            </div>
            <button
              onClick={handleBulkApproval}
              disabled={bulkLoading}
              className="bg-darkGreen3 text-lGrey px-4 py-2 rounded-lg hover:bg-darkGreen3-700 transition-all disabled:opacity-50"
            >
              {bulkLoading ? "Processing..." : `Approve Selected (${selectedRows.length})`}
            </button>
          </div>
        )}

        {/* Filter Controls Section - Responsive */}
        <div className="pb-4 bg-white dark:bg-gray-900">
          {/* DESKTOP FILTERS (md and up) - All in one row */}
          <div className="hidden md:flex flex-wrap items-center gap-3">
            {/* Search Input Field with Icon */}
            <div className="relative flex-grow min-w-[200px]">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="search"
                  className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  placeholder="Search remittance by number, branch, description..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            </div>

            {/* Start Date Input */}
            <div className="min-w-[150px]">
              <div className="relative">
                <input type="date" />
                <input
                  type="date"
                  value={filters.start_date}
                  onChange={(e) => handleFilterChange("start_date", e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                  max={filters.end_date || undefined}
                  placeholder="Start Date"
                />
              </div>
            </div>

            {/* End Date Input */}
            <div className="min-w-[150px]">
              <div className="relative">
                <input
                  type="date"
                  value={filters.end_date}
                  onChange={(e) => handleFilterChange("end_date", e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                  min={filters.start_date || undefined}
                  placeholder="End Date"
                />
              </div>
            </div>

            {/* Clear Dates Button - Only show when dates are selected */}
            {areDatesSelected && (
              <div className="min-w-[120px]">
                <button
                  onClick={handleClearDates}
                  className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                >
                  <XCircle className="w-4 h-4" />
                  Clear Dates
                </button>
              </div>
            )}

            {/* Download Button */}
            <div className="min-w-[160px]">
              <button
                onClick={handleDownloadCSV}
                className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                  ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
                disabled={!areDatesSelected || loadingCSV}
                title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
              >
                {loadingCSV ? (
                  <>
                    <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                    Downloading...
                  </>
                ) : (
                  <>
                    <Download className="w-4 h-4" />
                    Download CSV
                  </>
                )}
              </button>
            </div>
          </div>

          {/* MOBILE FILTERS (below md) - Stacked layout */}
          <div className="md:hidden flex flex-col gap-3">
            {/* Search - Full width on mobile */}
            <div className="w-full">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="search"
                  className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                  placeholder="Search remittance by number, branch, description..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            </div>

            {/* Filters grid for mobile */}
            <div className="grid grid-cols-2 gap-3">
              {/* Start Date - Half width on mobile */}
              <div className="col-span-1">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full px-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                    max={filters.end_date || undefined}
                    placeholder="Start"
                  />
                </div>
              </div>

              {/* End Date - Half width on mobile */}
              <div className="col-span-1">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full px-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                    min={filters.start_date || undefined}
                    placeholder="End"
                  />
                </div>
              </div>

              {/* Clear Dates Button - Full width when shown */}
              {areDatesSelected && (
                <div className="col-span-2">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )}

              {/* Download Button - Full width on mobile */}
              <div className="col-span-2">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      <span className="ml-2">Downloading...</span>
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      <span className="ml-2">Download CSV</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* DESKTOP help text (md and up) */}
          <div className="hidden md:flex items-center justify-between mt-2">
            {!areDatesSelected && (
              <p className="text-xs text-gray-500">
                Select start and end dates to enable download
              </p>
            )}
            {areDatesSelected && filteredItems.length > 0 && (
              <p className="text-sm text-gray-600">
                Showing {filteredItems.length} pending remittances from {filters.start_date} to {filters.end_date}
              </p>
            )}
          </div>

          {/* MOBILE help text (below md) */}
          <div className="md:hidden mt-3">
            {!areDatesSelected && (
              <p className="text-xs text-gray-500 text-center mb-2">
                Select start and end dates to enable download
              </p>
            )}
            {areDatesSelected && filteredItems.length > 0 && (
              <p className="text-sm text-gray-600 text-center">
                Showing {filteredItems.length} pending remittances
              </p>
            )}
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={data}
            pagination
            highlightOnHover
            striped
            customStyles={CustomStyles}
            noDataComponent={
              <div className="py-8 text-center text-gray-500">
                No pending remittance found
              </div>
            }
            expandableRows
            expandableRowsComponent={ExpandableComponent}
            selectableRows
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleCleared}
            contextActions={contextActions}
            persistTableHead
          />
        )}
      </div>
    </MainLayouts>
  );
};

export default GetPendingRemittance;
